import React from "react";
import "../../styles/Banners.css";
import "../../styles/Fonts.css";
import "../../styles/Containers.css";
import "../../styles/Colors.css";
import TopNavbarBack from "../../components/TopNavbarBack";
import GoToTop from "../../components/GoToTop";

export default function PolicyPrivacy() {
  return (
    <div className="">
      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbuttonHref={["/login"]}
        rbackground={["rectangle"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["dNone"]}
      />
      <div className="tutorial">
        <h2>حریم خصوصی و شرایط و ضوابط</h2>
        <h3 className="purple-1">1. معرفی</h3>
        <p className="yekan subject-2">
          ما در فودپلنر، دستورات غذایی متنوع را با رابط کاربری دوستانه فراهم
          کردیم تا بتوان از آنها را در تقویم برنامه ریزی غذایی اضافه کرد تا
          کاربران نظارت بهتری بر تغذیه خود داشته باشند. همچنین امکاناتی مثل لیست
          خرید، اعلان‌های لازم و ... را برای کاربر فراهم کرده‌ایم تا مدیریت
          آشپزخانه و غذا را آسان‌تر و دلنشین‌تر انجام دهد.
        </p>
        <br />
        <h3 className="purple-1">2. نکات دستور پخت غذاها</h3>
        <p className="yekan subject-2">
          دستورات غذایی همگی امتحان شده هستند و طبق اصول سازمان جهانی بهداشت،
          مورد مشکوکی در آنها وجود ندارد.
          <br />
          <br />
          ما تمام تلاشمان را برای اطلاع رسانی درباره حساسیت‌های غذایی و تداخلات
          غذایی انجام می‌دهیم. بنابراین بررسی تداخل غذایی در برنامه هفتگی و
          روزانه و حساسیت های غذایی بر عهده کاربر می باشد و فودپلنر مسئولیتی در
          قبال ایجاد هرگونه مشکل درباره دستورات غذایی ندارد.
          <br />
          <br />
          در صورت بارداری و شیردهی و همینطور داشتن بیماری قبل از استفاده از وب
          اپلیکیشن فودپلنر، حتما با پزشک و متخصص تغذیه مشورت نمایید.
        </p>
        <br />
        <h3 className="purple-1">3. اطلاعات شخصی</h3>
        <p className="yekan subject-2">
          اطلاعات دریافتی از کاربر تنها برای استفاده در فودپلنر می‌باشد و
          اطلاعاتی از قبیل رمز ورود به صورت رمزنگاری شده است. هرگونه محتوای
          خصوصی که شما به صورت دستی وارد می‌کنید (مانند لیست خرید و
          علاقه‌مندی‌ها) نیز به صورت محرمانه و امن ذخیره خواهد شد.
          <br />
          <br />
          هدف اصلی ما از جمع‌آوری اطلاعات شخصی، تسهیل در ارائه بهترین تجربه و
          خدمات به شما می‌باشد. این اطلاعات ممکن است برای بهبود برنامه، ارتباط
          با کاربران، ارائه دستورات غذایی شخصی‌سازی شده و ایجاد آمار و تحلیل‌ها
          در حوزه آشپزی و مواد غذایی مورد استفاده قرار گیرد.
          <br />
          <br />
          ما هم‌چنین ممکن است اطلاعات زیر را حین استفاده شما از سامانه تحت وب
          فودپلنر به صورت خودکار جمع‌آوری کنیم. لازم به ذکر است که این اطلاعات
          تنها جهت بهبود کیفیت خدمات و رضایتمندی شما استفاده می‌شود: اطلاعات
          مرتبط با نحوه استفاده کاربران از پنل وب مانند فراوانی استفاده از
          سرویس، مشکلات نرم افزاری و غیره، از طریق کوکی‌ها یا فناوری‌های مشابه.
          اطلاعات دستگاهی که از طریق آن از پنل وب استفاده می‌کنید مثل تلفن همراه
          هوشمند، تبلت، کامپیوتر شخصی و غیره، شامل نوع دستگاه، سیستم عامل و
          مشخصات سخت افزاری.
        </p>
        <br />
        <h3 className="purple-1">4. تراکنش های مالی</h3>
        <p className="yekan subject-2">
          تنها افراد بالای ۱۸ سال حق انجام معامله (خرید) در وب اپلیکیشن فودپلنر
          را دارند.
          <br />
          <br />
          پرداخت برای خرید اشتراک به منظور هزینه سرور، نگهداری سایت، پشتیبانی و
          توسعه، نگهداری دامنه، پرسنل و نیروی انسانی و ... انجام می‌پذیرد.
          <br />
          <br />
          محصول‌های خریدنی در وب اپلیکیشن فودپلنر اشتراک‌ مدت‌دار (یک ماهه) است
          که با خریداری آن‌ها کاربر به قسمت «تقویم»، «همه دستورات پخت» و همچنین
          قسمت «نمودارهای آماری» دسترسی خواهد داشت.
          <br />
          <br />
          فرایند خرید در وب اپلیکیشن فودپلنر به شرح زیر است:    <br />انتخاب بسته‌ی
          اشتراکی مورد نظر    <br />مشاهده‌ی پیش‌فاکتور   <br /> پرداخت از طریق درگاه اینترنتی
          <br />دریافت بسته‌ی اشتراکی
          <br />
          <br />
          اختلال در سرویس اینترنت یا هر دلیلی که باعث شود فرایند خرید به انجام
          نرسد باعث از بین رفتن حق کاربر نمی‌شود و در صورتی که مبلغی از حساب
          کاربر کسر شده باشد از طریق بانک به وی بازپرداخته خواهد شد.
        </p>
        <br />
        <h3 className="purple-1">5. امنیت</h3>
        <p className="yekan subject-2">
          ما تمامی تدابیر امنیتی لازم را برای جلوگیری از دسترسی غیرمجاز، سوء
          استفاده یا از دست رفتن اطلاعات شما اتخاذ کرده‌ایم. این شامل استفاده از
          فناوری رمزنگاری، اطلاعات الزامی و مکان‌یابی فیزیکی سرورهای ما می‌شود.
          تراکنش‌های مالی از طریق سامانه‌های بانکی صورت می‌گیرد و فودپلنر هیچ
          دخالتی در فرایند انتقال وجه از طریق کارت‌های بانکی ندارد. ما هیچ گونه
          دسترسی به اطلاعات کارت بانکی شما نداریم و درگاه پرداخت بانکی امنیت
          پرداخت و اطلاعات حساب شما را تامین می‌کند.
        </p>
        <br />
        <h3 className="purple-1">6. تغییرات در سیاست حریم خصوصی</h3>
        <p className="yekan subject-2">
          ممکن است سیاست حریم خصوصی ما در آینده تغییر کند. هر تغییری که در سیاست
          حریم خصوصی اتفاق بیفتد، به کاربران اطلاع داده خواهد شد و تغییرات جدید
          در این برنامه اعمال خواهند شد. با استفاده از برنامه و ادامه استفاده از
          آن، شما به تغییرات احتمالی در سیاست حریم خصوصی رضایت می‌دهید.
        </p>
        <br />
        <h3 className="purple-1">7. راه ارتباطی</h3>
        <p className="yekan subject-2">
          در صورتی که سوالی در مورد حریم خصوصی دارید، انتقاد یا پیشنهادی دارید
          یا نیاز به ارتباط با ما دارید، با یکی از روش‌های زیر با فودپلنر در
          میان بگذارید: 
          <br />
          پشتیبانی در تلگرام&nbsp;
          <a href="https://t.me/foodplanner_support" className="link yekan" target="_blank">foodplanner_support@</a> 
          <br />
          ایمیل فودپلنر&nbsp; 
          <a href='mailto:foodplanner_support@gmail.com' className="link yekan" target="_blank">foodplanner_support@gmail.com</a>
        </p>
      </div>
      <GoToTop />
    </div>
  );
}